import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeApiResponse, TypeGetReceivingLabelItemsResponse } from '~/types/receive.types';

type LabelItemsParams = {
  ownerCode: string;
  receivingRequestCodes: string;
};

/**
 * [입고요청관리] 라벨 아이템 조회 API
 */
const fetchReceivingLabelItems = async ({ ownerCode, receivingRequestCodes }: LabelItemsParams) => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetReceivingLabelItemsResponse['data']>>(
    `${API_ENDPOINT.RECEIVE_2.GET_RECEIVING_LABEL_ITEMS}/${ownerCode}/items`,
    { params: { receivingRequestCodes } }
  );
  return data.data;
};

/**
 * [입고요청관리] 라벨 아이템 조회 Mutation Hook
 */
export const useGetReceivingLabelItemsMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingLabelItems,
  });
};
